import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { Spinner, EmptyState } from "../components/ui";
import { AnnouncementCard } from "../components/AnnouncementCard";

export default function Announcements() {
  const q = useQuery({ queryKey: ["announcements"], queryFn: () => api("/announcements") });
  const list = q.data || [];
  return (
    <>
      <div className="page-header">
        <h1 className="t-h1">Alertas</h1>
      </div>
      {q.isLoading ? <Spinner /> : (
        <div className="page ulc-fade" style={{ maxWidth: 720 }}>
          {!list.length ? <EmptyState icon="megaphone" text="Sem comunicados de momento." /> : null}
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {list.map((a) => <AnnouncementCard key={a.id} a={a} />)}
          </div>
        </div>
      )}
    </>
  );
}
